import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { DATA_QUALITY_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData } from '../CustomUtils.js'
import './DataQualityReport.css'

const DATA_QUALITY_REPORT = gql(DATA_QUALITY_REPORT_QUERY)

export default function DataQualityReport({ location }) {
  console.log('DataQualityReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const params = new URLSearchParams(location.search)
  const updateHistory = params.get('in_update_history')

  useEffect(() => {
    console.log(`updateHistory: ${updateHistory}`)
    getData(null, DATA_QUALITY_REPORT, 'dataQualityReport', setResults, setGraphQLErrors, 'updateHistory', updateHistory)
  }, [updateHistory])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <div dangerouslySetInnerHTML={{ __html: results }} />
      </div>
    )
  }
}
